import { useLayout } from '@hana/shell';
import { Ar } from './Ar';
import { ArPad } from './ArPad';
import { ArPhone } from './ArPhone';

/** iPad → danh sách thẻ (Mint-AR-iPad), điện thoại → thẻ + chi tiết (Mint-AR-Phone); còn lại giữ bảng Mint-AR. */
export function ArRoute() {
  const layout = useLayout();
  return layout === 'phone' ? <ArPhone /> : layout === 'pad' ? <ArPad /> : <Ar />;
}
